import { io, Socket } from "socket.io-client";

const URL = import.meta.env.VITE_SERVER_URL || "http://localhost:3030";

export const createSocketConnection = (): Socket => {
  const socket = io(URL, {
    withCredentials: true, // for cookie-based auth
    // Both portals share a cookie jar under .univdiam.com. A header cannot ride
    // a WebSocket handshake, so the portal travels in the auth payload and the
    // server uses it to pick which cookie identifies us.
    auth: { portal: "customer" },
    transports: ["websocket"],
    autoConnect: false, // manual connect
    reconnection: true,
  });
  return socket;
};
